import React from "react";
import { escape2Html } from "../../util";
import SingleMessage from "./singleMessage.js";
import WeaLocaleProvider from "../../../../ecology9/wea-locale-provider";
import { Icon, Row, Col, Button, Pagination } from "antd";
import {
  WeaTab,
  WeaInput,
  WeaDialog,
  WeaNewScroll,
  WeaDatePicker
} from "ecCom";
import { observer } from "mobx-react";
const getLabel = WeaLocaleProvider.getLabel;

import * as API from "../../apis/index";

@observer
class MsgListPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      syncComponent: () => null,
      searchDialogVisible: false,
      searchParams: {
        title: "",
        fromDate: "",
        toDate: "",
        pageSize: 20,
        page: 1
      },
      searchListTotal: "",
      searchListDatas: [],
      showHighLight: false,
      searchLoading: false,
      changePage: 1
    };
  }
  static scroll = null;
  static searchListScroll = null;
  debounce = (fn, wait) => {
    var last = null;
    const context = this;
    var timer = null;
    return function() {
      const args = arguments;
      clearTimeout(timer);
      var now = new Date();
      if (!last) {
        last = now;
      }
      if (now - last >= wait) {
        fn.apply(context, args);
        last = now;
      } else {
        timer = setTimeout(function() {
          fn.apply(context, args);
        }, wait);
      }
    };
  };
  updateSyncCom(com) {
    this.setState(
      {
        syncComponent: com
      },
      () => {
        this.forceUpdate();
      }
    );
  }

  clickToRead = () => {
    this.props.setState({ flag: false });
    this.props.getMsgList(
      this.props.current,
      this.props.msgid,
      this.props.mintime
    );
  };

  setReaded = () => {
    API.setMsgRead({ allReadFlag: 1 }).then(res => {
      if (res) {
        this.props.getMsgTypeList();
      }
    });
    this.props.setState({
      unReadMsgValue: "none"
    });
  };

  onTabChange = v => {
    const currentArray = this.props.tabData.filter(
      item => item.viewcondition == v
    );
    !this.props.loading &&
      this.props.setState(
        {
          tabSelectedKey: v,
          refresh: true,
          selectState: currentArray ? currentArray[0].selectState : ""
        },
        () => {
          this.props.getMsgList(
            this.props.current,
            0,
            0,
            null,
            true,
            true,
            "",
            false,
            true
          );
        }
      );
  };

  onScroll = () =>
    this.debounce(e => {
      const position = e.target && e.target.scrollTop;
      this.props.getReadedMsg(position);
    }, 200);

  addMore = () => {
    this.props.getMsgList(
      this.props.current,
      this.props.msgid,
      this.props.mintime,
      null,
      true,
      false
    );
  };

  getNew = () => {
    this.props.getNewMsgList(this.props.current, this.props.maxtime, 1, () => {
      if (this.props.current !== "0") {
        this.props.setMsgRead();
      }
      this.scroll && this.scroll.refs.weaBaron.scrollToLast();
    });
  };

  getSearchMsgList = (pageSet = false) => {
    const { searchParams, changePage } = this.state;

    this.setState({
      searchLoading: true,
      searchParams: {
        ...searchParams,
        page: pageSet ? changePage : 1
      },
      changePage: pageSet ? changePage : 1
    });

    const { current: id } = this.props;

    API.getSearchMsgList({
      ...searchParams,
      id,
      page: pageSet ? changePage : 1
    }).then(res => {
      if (res.status) {
        this.setState(
          {
            searchListDatas: res.data,
            searchListTotal: res.count,
            showHighLight: true
          },
          () => {
            this.setState({ searchLoading: false });
            setTimeout(() => {
              this.searchListScroll &&
                this.searchListScroll.refs.weaBaron.scrollToLast();
            }, 100);
          }
        );
      }
    });
  };

  renderList() {
    let leftScrollHeight =
      this.props.offsetHeight === 0 ? 618 : 618 + this.props.offsetHeight - 80;
    if (this.props.unReadMsgValue === "block") {
      // leftScrollHeight -= 25;
    }
    if (window.innerHeight < 900) {
      leftScrollHeight = 500;
    }
    leftScrollHeight -= 48;
    return (
      <React.Fragment>
        {/* 顶部点击 */}
        <div
          className="wea-messageCenter-stickyinfo"
          style={{ display: "none" || this.props.unReadMsgValue }}
        >
          <div style={{ float: "left", "margin-right": "10px" }}>
            <a onClick={this.clickToRead}>
              <Icon className="icon" type="exclamation-circle" />
              {getLabel("504399", "你还有尚未读的消息,请点击阅读")}
            </a>
          </div>

          <div style={{ float: "right" }}>
            <a onClick={this.setReaded}>全部置为已读</a>
          </div>
        </div>
        {/* 顶部 tips 出现时的 占位符 */}
        {/* {this.state.unReadMsgValue === "block" && (
                <div style={{ height: 25 }} />
              )} */}
        {/* 提醒有该tab */}
        <div className="sticky-top-tab">
          <WeaTab
            datas={this.props.tabData}
            keyParam="viewcondition" //主键
            countParam="groupid" //数量
            selectedKey={this.props.tabSelectedKey}
            onChange={this.onTabChange}
            buttons={[
              <i
                className="icon-coms-search wea-messageCenter-list-search"
                title={getLabel("529406", "查找消息")}
                onClick={() =>
                  this.setState(
                    {
                      searchDialogVisible: true,
                      searchParams: {
                        title: "",
                        fromDate: "",
                        toDate: "",
                        pageSize: 20,
                        page: 1
                      },
                      changePage: 1
                    },
                    () => this.getSearchMsgList()
                  )
                }
              />
            ]}
          />
        </div>
        <div style={{ height: 48 }} />
        <WeaNewScroll
          ref={e => {
            this.props.scroll(e);
            this.scroll = e;
          }}
          height={leftScrollHeight}
          style={{ marginLeft: "-10px" }}
          onScroll={this.onScroll}
        >
          {this.props.msgList.length === 0 && !this.props.loading ? (
            <div className="wea-messageCenter-nomsg">
              <div className="nomsg-container">
                <span style={{ fontSize: 80 }}>
                  <i className="icon-coms-blank" />
                </span>
                <br />
                <span className="wea-f12">{getLabel("83553", "暂无消息")}</span>
              </div>
            </div>
          ) : (
            <div className="click-look-more">
              <span>
                {this.props.loading ? (
                  <Icon type="loading" />
                ) : (
                  <React.Fragment>
                    {this.props.newGetMsgList.length > 0 ? (
                      <span onClick={this.addMore}>
                        <Icon type="clock-circle-o" />
                        <a className="wea-f12" href="javascript:void(0);">
                          {getLabel("384653", "点击加载更多")}
                        </a>
                      </span>
                    ) : (
                      <span className="wea-f12" className="no-more">
                        {getLabel("390064", "没有更多啦")}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </span>
            </div>
          )}
          {this.props.msgList.length > 0 &&
            this.props.msgList.map(data => {
              return (
                <SingleMessage
                  {...data}
                  imgSrc={data.showimage || ""}
                  name={data.name || ""}
                  time={data.time || ""}
                  link={data.link || ""}
                  title={data.title || ""}
                  context={data.context || ""}
                  updateSyncCom={com => this.updateSyncCom(com)}
                />
              );
            })}
        </WeaNewScroll>
        <div
          className="wea-messageCenter-stickyinfo"
          style={{ display: this.props.newMsgValue }}
          onClick={this.getNew}
        >
          <div
            className="bottom-left-title"
            dangerouslySetInnerHTML={{
              __html: escape2Html(
                this.props.messagetype + " " + this.props.title
              )
            }}
          />
          <div style={{ float: "right" }}>
            <a
              style={{
                "border-style": "none",
                cursor: "pointer",
                "background-color": "	#BBDBF9"
              }}
            >
              {this.props.count}
              {getLabel("126991", "条新消息")}
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderCustom() {
    const { currentMsgType } = this.props;
    if (!currentMsgType[0] || !currentMsgType[0].pc_url) {
      return <span style={{ color: "#f00" }}>组件错误！</span>;
    }
    return (
      <React.Fragment>
        <iframe width="100%" height="100%" src={currentMsgType[0].pc_url} />
      </React.Fragment>
    );
  }

  renderDialog = () => {
    const {
      searchDialogVisible,
      searchParams,
      searchListDatas,
      searchListTotal,
      showHighLight,
      searchLoading
    } = this.state;
    const cls = "wea-messageCenter-search-dialog";
    return (
      <WeaDialog
        title={getLabel("529406", "查找消息")}
        className={cls}
        visible={searchDialogVisible}
        style={{ width: 830, height: 560 }}
        onCancel={() => this.setState({ searchDialogVisible: false })}
        maskClosable={false}
        hasScroll
      >
        <div className={`${cls}-content`}>
          <div className={`${cls}-content-search`}>
            <Row style={{ textAlign: "center", lineHeight: "37px" }}>
              <Col span={5}>
                <WeaInput
                  id="searchInput"
                  placeholder={getLabel(83788, "请输入关键字搜索")}
                  value={searchParams.title}
                  onEnter={this.getSearchMsgList}
                  onChange={value => {
                    this.setState({
                      searchParams: { ...searchParams, title: value },
                      showHighLight: false,
                      changePage: 1
                    });
                  }}
                />
              </Col>
              <Col span={15} style={{ marginLeft: "20px" }}>
                <Row>
                  <Col span={12}>
                    <WeaDatePicker
                      value={searchParams.fromDate}
                      placeholder={getLabel("529408", "请选择开始日期")}
                      viewAttr={2}
                      onChange={value =>
                        this.setState({
                          searchParams: {
                            ...searchParams,
                            fromDate: value
                          },
                          changePage: 1
                        })
                      }
                    />
                  </Col>
                  <Col span={12}>
                    <WeaDatePicker
                      value={searchParams.toDate}
                      placeholder={getLabel("529409", "请选择结束日期")}
                      viewAttr={2}
                      onChange={value =>
                        this.setState({
                          searchParams: {
                            ...searchParams,
                            toDate: value
                          },
                          changePage: 1
                        })
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={1} style={{ marginLeft: "30px" }}>
                <Button
                  type="primary"
                  onClick={this.getSearchMsgList}
                  style={{ marginBottom: "3px" }}
                >
                  {getLabel("388113", "搜索")}
                </Button>
              </Col>
            </Row>
          </div>
          {searchLoading ? (
            <Icon type="loading" />
          ) : Array.isArray(searchListDatas) && searchListDatas.length > 0 ? (
            <React.Fragment>
              <WeaNewScroll
                ref={e => {
                  this.searchListScroll = e;
                }}
                height={430}
              >
                <div className={`${cls}-content-list`}>
                  {searchListDatas.map(data => {
                    return (
                      <SingleMessage
                        {...data}
                        showHighLight={showHighLight}
                        imgSrc={data.showimage || ""}
                        name={data.name || ""}
                        time={data.time || ""}
                        link={data.link || ""}
                        title={data.title || ""}
                        context={data.context || ""}
                        searchValue={searchParams.title}
                      />
                    );
                  })}
                </div>
              </WeaNewScroll>
              <Pagination
                defaultCurrent={1}
                total={searchListTotal}
                showQuickJumper
                showSizeChanger
                pageSizeOptions={["20", "30", "40", "50"]}
                showTotal={total =>
                  `${getLabel("83698", "共")}${searchListTotal}${getLabel(
                    "128218",
                    "条"
                  )}`
                }
                pageSize={searchParams.pageSize}
                current={searchParams.page}
                defaultCurrent={searchParams.page}
                onShowSizeChange={(page, pageSize) =>
                  this.setState(
                    {
                      searchParams: { ...searchParams, page, pageSize },
                      changePage: page
                    },
                    () => this.getSearchMsgList()
                  )
                }
                onChange={v =>
                  this.setState(
                    {
                      searchParams: { ...searchParams, page: v },
                      changePage: v
                    },
                    () => this.getSearchMsgList(true)
                  )
                }
              />
            </React.Fragment>
          ) : (
            <div className={`${cls}-content-nodata`}>
              {getLabel("529411", "暂无匹配消息数据")}
            </div>
          )}
        </div>
      </WeaDialog>
    );
  };

  render() {
    let isCustom = false;
    const { currentMsgType } = this.props;
    if (currentMsgType[0] && currentMsgType[0].pc_url) {
      isCustom = true;
    }
    return (
      <div className="wea-messageCenter-leftList">
        <this.state.syncComponent />
        {isCustom ? this.renderCustom() : this.renderList()}
        {this.renderDialog()}
      </div>
    );
  }
}

export default MsgListPanel;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/message-center/msg-list-panel.js